<template>
	<div id="page">
		<div class="page-content">
			<div class="fixed-top-box">
				<div class="page-title page-title-small">
					<h2>
						<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
						درخواست مرخصی
						<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
					</h2>
					<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
					<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
				</div>
				<div class="card header-card shape-rounded" data-card-height="100">
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
				</div>
				<div class="card card-style mb-2">
					<div class="p-3 d-flex">
						<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
							<i class="fa fa-filter text-white"></i>
						</button>
						<div class="filter-row-scrollable">
							<div @click="lstFilter('All',null)" id="All" class="filterSelectItem filter-scrollable-box selected">همه </div>
							<div @click="lstFilter('Approved',true)" id="Approved" class="filterSelectItem filter-scrollable-box ">تایید شده</div>
							<div @click="lstFilter('Rejected',false)" id="Rejected" class="filterSelectItem filter-scrollable-box ">رد شده</div>

						</div>
					</div>
				</div>
			</div>

			<span data-menu="menu-language" class="optionMenu"></span>

			<div class="main-content-box">
				<div class="card card-style mb-2" v-for="item in VacationList" :key="item.vacationId">
					<div class="p-3" :id="'Invite-'+item.vacationId">
						<button data-toggle="collapse" type="button" :data-target="'#collapse-'+item.vacationId" class="no-effect collapsed accordion-btn" aria-expanded="false">
							<span class="d-flex justify-content-between align-items-center">
								<span class="d-flex justify-content-between" style="width:90%">
									<span class="text-muted d-inline-flex align-items-center">
										<!--اگر کاربر درخواست دهنده تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user color-green2-dark ml-2"></i>-->
										<!--تصویر پروفایل کاربر ثبت کننده-->
										<img v-if="item.userImg!=null && item.userImg!=''" :src="item.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-circle color-green2-dark ml-2 font-30"></i>

										<span>{{item.personTitle}}</span>
									</span>
									<b class="font-13 text-dark"><i class="fa fa-calendar text-warning ml-2"></i> {{item.vacationDate}}</b>
								</span>
								<i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
							</span>
						</button>
					</div>

					<div class="collapse border-t" :id="'collapse-'+item.vacationId" @click.prevent="openDetails(item.vacationId)">
						<div class="d-flex justify-content-between align-items-center px-4 pt-3">
							<span><i class="fa fa-check-square color-pink1-dark ml-2"></i> {{item.vacationTypeTitle}}</span>
							<span><i class="fa fa-check-square color-pink2-dark ml-2"></i> {{item.localTypeTitle}}</span>
						</div>
						<div class="d-flex justify-content-between py-3 pr-4 pl-3">
							<div style="width:90%">
								<div class="d-flex justify-content-between align-items-center">
									<span class="text-muted d-inline-flex align-items-center">
										<!--اگر کاربر مدیر تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user-circle color-magenta2-light ml-2 font-30"></i>-->
										<!--تصویر پروفایل مدیر-->
										<img v-if="item.managerUserImg!=null && item.managerUserImg!=''" :src="item.managerUserImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-shield color-magenta2-light ml-2"></i>
										{{item.managerUserTitle}}
									</span>
									<span class="badge font-10 position-static mt-0 badge-primary">{{item.statusTitle}}</span>
								</div>
							</div>
							<span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14 mt-2"></i></span>
						</div>
					</div>

				</div>
				<div class="card card-style" v-if="VacationList.length==0 && pageLoading==false">
					<div class="content">
						<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
						<p class="text-center py-3">هیج موردی یافت نشد.</p>
					</div>
				</div>

				<div class="card card-style" v-if="pageLoading==false && NoMoreData==false && VacationList.length>0 && VacationList.length%10==0">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<button class="btn btn-outline-info rounded-m" @click="GetNextPage">نمایش بیشتر</button>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'VacationEdit', params: { VacationId: vacationId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>

					<button @click="SendVacationMessage" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-check color-magenta2-dark float-right font-14"></i>ارسال برای تایید</span><i class="fa fa-angle-left"></i></button>
					<button @click="DeleteVacation" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

				</div>
				<div class="clear"></div>
			</div>
		</div>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn">
				<router-link to="/VacationCreate">
					<div class="icon icon-m rounded-m color-white bg-green2-light">
						<i class="fa fa-plus"></i>
					</div>
				</router-link>
			</div>
		</transition>
		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">

						<div class="w-100 search-box rounded-m position-relative mb-3">
							<i class="fa fa-search pr-3"></i>
							<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
						</div>

						<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

						<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>
						<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="page=1;GetVacationList()">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>
		<Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
	</div>
</template>

<script>
	import VueSimpleAlert from 'vue3-simple-alert';
	import HelpMenu from '../Components/HelpMenu.vue';
	import calendarFilter from '../Components/CalendarFilter.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu,
			"calendar-filter": calendarFilter,
			"myTeamList": MyTeamList,
		},
		data() {
			return {
				pageLoading: false,
				vacationId: 0,
				page: 1,
				NoMoreData: false,
				searchKey: "",
				date: null,
				status: null,
				userId: null,
				list: []
			};
		},
		created() {
			this.GetVacationList();
		},
		computed: {
			VacationList() {
				return this.list;
			},
		},
		methods: {
			selectDate(d) {
				this.date = d;
			},
			selectUser(d) {
				this.userId = d;
			},
			showAddButton() {
				this.pageLoaded = true;
			},
			showMenu(t) {
				this.vacationId = t.vacationId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			SendVacationMessage() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm(
					"آیا مایل به ارسال پیام جهت برسی و تایید برای مدیر مرتبط هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {
					this.pageLoading = true;
					this.$http
						.get("Vacation/SendVacationMessage?id=" + this.vacationId)
						.then((resData) => {
							this.pageLoading = false;
							var res = resData.data;
							if (res.isSuccess) {
								this.showSuccessMessage(res.message);
							} else {
								this.showErrorMessage(res.message);
							}

						});
				});

			},
			DeleteVacation() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm(
					"آیا مایل به حذف این مورد هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {
					this.pageLoading = true;
					this.$http
						.get("Vacation/Delete?id=" + this.vacationId)
						.then((data) => {
							var res = data.data;
							this.pageLoading = false;
							if (res.isSuccess) {
								this.GetVacationList();
							} else {
								this.showErrorMessage(res.message);
							}
						});
				});
			},
			GetNextPage() {
				this.page = this.page + 1;
				this.GetVacationList();
			},
			lstFilter(filterSelect, status) {
				this.status = status;
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(filterSelect).classList.add('selected');
				this.page = 1;
				this.GetVacationList();
			},
			GetVacationList() {
				this.pageLoading = true;
				if (this.page == 1)
					this.list = [];
				this.$http
					.get("Vacation/GetList", {
						params: {
							searchKey: this.searchKey,
							date: this.date,
							userId: this.userId,
							page: this.page,
							status: this.status,

						}
					}).then((data) => {
						this.list = this.list.concat(data.data);
						if (this.list.length <= 0)
							this.NoMoreData = true;
						this.pageLoading = false;
					});

			},
			openDetails(vacationId) {
				this.$router.push({ name: 'VacationEdit', params: { VacationId: vacationId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
		},
		mounted() {
			document
				.querySelectorAll(".menu-box-right")
				.forEach((a) => (a.style.display = "block"));
		},
	}
</script>